import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
// import goalService from './goalService'
import { getAllCategoryService } from "./services";


const initialState = {
    categories: [],
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: ''

}


//get goas
export const getCategories = createAsyncThunk('categories/getAll', async (query:any,thunkAPI:any) => {
    try {
        const res = await getAllCategoryService(query);
        if (res?.status === 200) {

            return res?.data;

            
        }

    } catch (error:any) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)

    }

})





export const productCategorySlice = createSlice({
    name: 'category',
    initialState,
    reducers: {
        reset: (state:any) => initialState
    },
    extraReducers: (builder:any) => {
        builder.addCase(getCategories.pending, (state:any) => {
            state.isLoading = true

        })
        .addCase(getCategories.fulfilled, (state:any, action:any) => {
            state.isLoading = false
            state.isSuccess = true
            state.categories = action.payload

        })
        .addCase(getCategories.rejected, (state:any, action:any) => {
            state.isLoading = false
            state.isError = true
            state.message = action.payload


        })
    }
})
export const { reset } =  productCategorySlice.actions
export default productCategorySlice.reducer